import React, {  useState,useEffect } from "react";
import "./Retinofive.css";

function Retinofive({leftSelection,rightSelection,handleNext,handlePrev}) { 
//state
const [leftChecked1, setleftChecked1] = useState(false);
const [leftChecked2, setleftChecked2] = useState(false);

const [rightChecked1, setrightChecked1] = useState(false);
const [rightChecked2, setrightChecked2] = useState(false);

const [leftPick, setLeftPick] = useState(leftSelection);
const [rightPick, setRightPick] = useState(rightSelection);

useEffect(() => {
  if("R5" in leftPick ){
    if(0 in leftPick.R5){
    setleftChecked1(true)
    }
    if(1 in leftPick.R5){
      setleftChecked2(true)
    }
   
  }
  if("R5" in rightPick ){
    if(0 in rightPick.R5){
      setrightChecked1(true)
      }
      if(1 in rightPick.R5){
        setrightChecked2(true)
      }
     
  } 
});
const deleteKey =(obj,keym)=>{
  delete obj[keym]
  return obj
}
const handleChange=(which, pick, position)=>{
  if(which==="right"){  
    if(("R5" in rightPick) || Object.keys(rightPick).length===0){
      //add or remove it
      if("R5" in rightPick){
        var obk =  {...rightPick.R5}
       
        if(rightPick.R5[position] !== undefined){
          
          var obj = deleteKey(obk, position)
         if(position===0){
          setRightPick({R5: obj })
          setrightChecked1(false)
         }
         if(position===1){
          setRightPick({R5: obj })
          setrightChecked2(false)
         }
         if(Object.keys(obj).length===0){
          
          setRightPick({})
         }
       
          }else{
            if(position===0){

              setRightPick({R5:{...rightPick.R5, 0:pick}}) 
              setrightChecked1(true)
             }
             if(position===1){
              setRightPick({R5:{...rightPick.R5, 1:pick}})
              setrightChecked2(true)
             }
            
          }
        // setrightPick({})
        // setrightChecked1(false)
      }
     if(Object.keys(rightPick).length===0){
      if(position===0){
        setRightPick({R5:{0:pick}});
        setrightChecked1(true)
       }
       if(position===1){
        setRightPick({R5:{1:pick}});
        setrightChecked2(true)
       }
    
     }
    }
     if(!("R5" in rightPick )&& Object.keys(rightPick).length>0){
      alert("You already selected Retinopathy Grade")
    } 

  }
  if(which==="left"){
    
    if(("R5" in leftPick) || Object.keys(leftPick).length===0){
      //add or remove it
      if("R5" in leftPick){
        var obk =  {...leftPick.R5}
        
        if(leftPick.R5[position] !== undefined){
        
          var obj = deleteKey(obk, position)
         if(position===0){
          setLeftPick({R5: obj })
          setleftChecked1(false)
         }
         if(position===1){
          setLeftPick({R5: obj })
          setleftChecked2(false)
         }
         if(Object.keys(obj).length===0){
          
          setLeftPick({})
         }
        
          }else{
            if(position===0){

              setLeftPick({R5:{...leftPick.R5, 0:pick}}) 
              setleftChecked1(true)
             }
             if(position===1){
              setLeftPick({R5:{...leftPick.R5, 1:pick}})
              setleftChecked2(true)
             }
            
          }
        // setLeftPick({})
        // setleftChecked1(false)
      }
     if(Object.keys(leftPick).length===0){
      if(position===0){
        setLeftPick({R5:{0:pick}});
        setleftChecked1(true)
       }
       if(position===1){
        setLeftPick({R5:{1:pick}});
        setleftChecked2(true)
       }
       
     }
    }
     if(!("R5" in leftPick )&& Object.keys(leftPick).length>0){
      alert("You already selected Retinopathy Grade")
    } 
  

  
}
 
}
const HandleNextin =()=>{
  var data ={
    Rleft: leftPick,
    Rright: rightPick
  }
 handleNext(data)
 if((rightChecked1 && rightChecked2  
  )){
  localStorage.setItem("RRight5",
  " Treated proliferative retinopathy present")
 }else{
  localStorage.setItem("RRight5",
  "")
 }
 if((leftChecked1 && leftChecked2  
  )){
  localStorage.setItem("RLeft5",
   "Treated proliferative retinopathy present")
 }else{
  localStorage.setItem("RLeft5",
  "")
 }
}
const HandlePrevIn =()=>{
  var data ={
    Rleft: leftPick,
    Rright: rightPick
  }
  handlePrev(data)
  if((rightChecked1 && rightChecked2  
    )){
    localStorage.setItem("RRight5",
    " Treated proliferative retinopathy present")
   }else{
    localStorage.setItem("RRight5",
    "")
   }
   if((leftChecked1 && leftChecked2  
    )){
    localStorage.setItem("RLeft5",
     "Treated proliferative retinopathy present")
   }else{
    localStorage.setItem("RLeft5",
    "")
   }
}
    return (  
        <> 
      <div className="nav navbar-expand-lg sticky-top shadow text-center" style={{marginBottom: "10px", backgroundColor: "#000"}}>  
        <div className="container">
            <p className="display-6 text-light text-center">
            R3S: All present
              </p>
          </div>
        </div>
        <div className="container">
          <div className="container">
            <div className="row">
            <div className="Image shadow col-xl-4 col-md-6">
          <img  className="HeaderSide img-fluid" style={{ height: "auto"}} src={require('../../assests/Images/ret5.jpg')} alt="retina" />
          <div className="Caption text-dark">
            <h5>Source: IDRiD Dataset</h5>
          </div>
          </div>
          <div className="SideTable col-xl-8 col-md-6">
            <div className="container">
            <table className="shadow"  style={{borderRadius: "10px", margin: "5px"}}>
              <tr style={{backgroundColor: "#000"}}>
                <th>
                Criteria
                </th>
                <th>Right Eye
               (tick if present)</th>
               <th>Left Eye
               (tick if present)</th>
              </tr>
              <tr>
                <td className="text-dark">Peripheral laser scars</td>
                <td><form>
                <input type="checkbox" 
                 checked={rightChecked1}  
                 value="Peripheral laser scars"
                className="CheckBox" id="myCheckRight" 
                onChange={(e) => 
                  {handleChange("right",e.target.value,0)}
                  }/>
                    </form></td>
                <td><form>
                <input type="checkbox" 
                value="Peripheral laser scars"
                checked={leftChecked1}
                className="CheckBox" id="myCheckleft" 
                onChange={(e) =>
                 {handleChange("left",e.target.value,0)}}/>
               
                  </form></td>
              </tr>
              <tr style={{backgroundColor: "#e9e9e9"}}>
                <td className="text-dark">Stable retinal appearance with no R3A lesions (Compare current and 
                  previous photos if 
                  available)</td>
                <td><form>
                <input type="checkbox" 
                 checked={rightChecked2} 
                className="CheckBox" id="myCheckRight" 
                onChange={(e) => 
                  {handleChange("right",e.target.value,1)}
                  }/>
                    </form></td>
                <td><form>
                <input type="checkbox"  checked={leftChecked2} 
                className="CheckBox" id="myCheckleft" 
                onChange={(e) => {handleChange("left",e.target.value,1)}}/>
                  </form></td>
              </tr>
              
            </table>
            <span ><span  className="RigthAnswer bg-primary text-light">Right eye:</span>
            <span className="AnswerDisplay">{(rightChecked1 && rightChecked2)?"Treated proliferative retinopathy present":""}
            </span></span>
            <span><span  className="LeftAnswer bg-dark text-light">Left eye:&nbsp;&nbsp;&nbsp;</span>
            <span  className="AnswerDisplay">{(leftChecked1 && leftChecked2 )?"Treated proliferative retinopathy present":""}
            </span></span>
            </div>
           
          </div>
          <div className="container">
                <div className="row">
                <div className="col-xl-4 col-md-6"></div>
                <div className="col-xl-4 col-md-6 text-center">
                <button className="btn btn btn-dark"
                  onClick={()=>{HandlePrevIn()}}
                  >Previous</button>&nbsp;
                  <button className="btn btn btn-primary"
                  onClick={()=>{HandleNextin()}}
                  >Next</button>
                </div>
                
                
                
                <div className="col-xl-4 col-md-6"></div>
              </div>
            </div>
            </div>
          </div>
          
        </div>
        
        </>
        
      );

    }

  
 
export default Retinofive;